import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { declineBotUser, approveBotUser } from 'actions/user';
import Button from 'components/Button';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import Select from 'components/Select';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import UserDeclineReason from 'pages/admin-users/UserDeclineReason';
import { getGroups } from 'actions/groups';
import { Row, Title, SubTitle, DecisionTitle } from 'styles/pages/admin-users';

const UserDecision = ({ user, fetchAllUser }) => {
  const [declineReasonDialog, setDeclineReason] = useState(false);
  const [groups, setGroups] = useState(undefined);
  const [selectedGroup, setGroup] = useState(undefined);
  const dispatch = useDispatch();
  const status = user?.UserData?.Status;

  useEffect(() => {
    const fetchGroups = async () => {
      const data = await dispatch(getGroups());
      setGroups(data);
    };

    if (groups === undefined) {
      fetchGroups();
    }
  }, [dispatch, groups]);

  useEffect(() => {
    const group = user?.UserData?.Group;
    if (group && !selectedGroup) {
      setGroup(group);
    }
  }, [dispatch, user, selectedGroup]);

  return (
    <div style={{ background: '#fff', padding: 10 }}>
      <DecisionTitle>
        User Submitted Information
        {status ? (
          <span
            style={{
              float: 'right',
              color:
                status === 'InProcess'
                  ? 'orange'
                  : status === 'Declined'
                  ? 'red'
                  : 'green',
            }}>
            {status}
            {status === 'InProcess' ? (
              <HourglassEmptyIcon style={{ float: 'right' }} />
            ) : status === 'Declined' ? (
              <CloseIcon style={{ float: 'right' }} />
            ) : (
              <CheckIcon style={{ float: 'right' }} />
            )}
          </span>
        ) : null}
      </DecisionTitle>
      <Row>
        <div>
          <Title>Name</Title>
          <SubTitle>{user?.UserData?.User?.FullName}</SubTitle>
        </div>
        <div>
          <Title>Email</Title>
          <SubTitle>{user?.User}</SubTitle>
        </div>
      </Row>

      <Row>
        <div>
          <Title>Company Name</Title>
          <SubTitle>{user?.UserData?.User?.Company}</SubTitle>
        </div>
        <div>
          <Title>Address</Title>
          <SubTitle>
            {user?.UserData?.User?.AddressLineOne},
            {user?.UserData?.User?.AddressLineTwo?.length > 0
              ? `${user?.UserData?.User?.AddressLineTwo},`
              : null}
            {user?.UserData?.User?.City}
            {user?.UserData?.User?.ZipCode},
            {user?.UserData?.User?.StateProvince},
            {user?.UserData?.User?.Country}
          </SubTitle>
        </div>
      </Row>

      <Row>
        <div>
          <Title>Company Website URL</Title>
          <SubTitle>{user?.UserData?.User?.CompanyUrl}</SubTitle>
        </div>
        <div>
          <Title>Business Type</Title>
          <SubTitle>{user?.UserData?.User?.BusinessType}</SubTitle>
        </div>
      </Row>

      <Row style={{ gridTemplateColumns: '1fr' }}>
        <div>
          <Title>Tell us about your work or your business</Title>
          <SubTitle>{user?.UserData?.User?.CompanyInfo}</SubTitle>
        </div>
      </Row>

      <Row style={{ gridTemplateColumns: '1fr' }}>
        <div>
          <Title>Resell Number / Trade ID / PST#</Title>
          <SubTitle>{user?.UserData?.User?.CompanyNumber}</SubTitle>
        </div>
      </Row>

      <Row style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
        <div>
          <Title>Do you have a home-based business?</Title>
          <SubTitle>{user?.UserData?.User?.HomeBased}</SubTitle>
        </div>
        <div>
          <Title>Do you have a physical retail store?</Title>
          <SubTitle>{user?.UserData?.User?.PhysicalStore}</SubTitle>
        </div>
        <div>
          <Title>Do you have your own decorating equipment?</Title>
          <SubTitle>{user?.UserData?.User?.DecoratingEquipment}</SubTitle>
        </div>
      </Row>

      <Row style={{ gridTemplateColumns: '1fr' }}>
        <div>
          <Title>How did you hear about us ?</Title>
          <SubTitle>{user?.UserData?.User?.HearAbout}</SubTitle>
        </div>
      </Row>

      {groups && (
        <Row style={{ gridTemplateColumns: '1fr' }}>
          <div>
            <Title>Groups</Title>
            <Select
              options={groups}
              valueKey='name'
              labelKey='name'
              value={{ name: selectedGroup }}
              onChange={(v) => setGroup(v)}
            />
          </div>
        </Row>
      )}

      {groups && selectedGroup && (
        <Button
          title='Approve'
          disabled={status === 'Active'}
          containerStyle={{
            backgroundColor: 'green',
            color: '#fff',
            fontWeight: 'bold',
            boxShadow: '4px 4px 20px rgba(0, 0, 0, 0.05)',
            textTransform: 'none',
            borderRadius: '3px',
            fontSize: '16px',
            marginRight: 20,
            opacity: status === 'Active' ? 0.3 : 1,
          }}
          startIcon={<CheckIcon />}
          onClick={async () => {
            const payload = {
              userId: user?.UserData?.ID,
              userEmail: user?.User,
              groupName: selectedGroup,
            };

            await dispatch(approveBotUser(payload));
            setDeclineReason(false);
            fetchAllUser();
          }}
        />
      )}
      <Button
        title='Decline'
        disabled={status === 'Declined'}
        onClick={() => setDeclineReason(true)}
        containerStyle={{
          backgroundColor: 'red',
          color: '#fff',
          fontWeight: 'bold',
          boxShadow: '4px 4px 20px rgba(0, 0, 0, 0.05)',
          textTransform: 'none',
          borderRadius: '3px',
          fontSize: '16px',
          opacity: status === 'Declined' ? 0.3 : 1,
        }}
        startIcon={<CloseIcon />}
      />

      {declineReasonDialog && (
        <UserDeclineReason
          open={declineReasonDialog}
          onClose={async (data) => {
            if (data) {
              const payload = {
                userId: user?.UserData?.ID,
                declineReason: data,
                userEmail: user?.User,
              };

              await dispatch(declineBotUser(payload));
            }
            setDeclineReason(false);
            fetchAllUser();
          }}
        />
      )}
    </div>
  );
};

export default UserDecision;
